import * as catalogos from 'app/idiomas/i18n/perfiles/catalogos/zh2';
export const locale = {
  lang: 'zh2',
  data: {
    'GENERICSURVEY': {
      'CATALOGOS': {
        'broker': catalogos.institutos,
      },
      'TITULO': '通用调查报告',
      'SUBTITULO': '通过输入查询通用调查报告',
      'CAMPOS': {
        'Token': '代币',
      },
      'RESULTADOS': {
        'CARGANDO': '加载搜索结果',
        'TITULO': '结果',
        'ENCONTRADAS': '找到的用户总数',
        'DESCARGAR': '下载Excel格式的资料',
        'SINRESULTADOS': '找不到指定令牌的用户'
      }
    }
  }
};
